import Splide from "@splidejs/splide";

function contentsSlider(): void {
  const splideElements = document.querySelectorAll("[id^='splide']"); // IDが'splide'で始まる要素を取得

  splideElements.forEach((element) => {
    const splide = new Splide(element as HTMLElement, {
      autoplay: true,
      type: "loop",
      perPage: 1,
      pagination: false,
      arrows: false,
      updateOnMove: true,
      pauseOnHover: false,
      padding: {
        left: "92.5px",
        right: "92.5px",
      },
      gap: "-20%",
      speed: 1000, // スライダーのスピードを遅くする（ミリ秒単位）
      breakpoints: {
        768: {
          padding: {
            left: "24px",
            right: "24px",
          },
          gap: "-20%",

        },
      },
    });

    try {
      splide.mount();
    } catch (error) {
      console.error("contentsSliderのSplideの初期化に失敗しました:", error);
    }
  });
}

export { contentsSlider };
